import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/business/business.ts
import { Exception } from "@wbk/logger";
var business = (body) => __async(void 0, null, function* () {
  try {
    const res = yield fetch("https://formbucket.com/f/buk_Dllr6QO09kyRwPlofIr8sO1r", {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        accept: "application/javascript",
        "content-type": "application/json"
      }
    });
    if (!res.ok) {
      throw new Error("Failed to submit");
    }
    return yield res.json();
  } catch (error) {
    throw new Exception({
      error,
      name: "businessException"
    });
  }
});

export {
  business
};
//# sourceMappingURL=chunk-VRFQUQ4L.mjs.map